import React, { useState } from "react";
import { NavLink, Link, useNavigate } from "react-router-dom";
import { useAuth } from "../../../AuthContext"; 
import "./AdminNavbar.css";
import LogoImg from '../../../Images/Logo_Invis.png';

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  const { user, currentUser, logout } = useAuth();
  const me = user ?? currentUser ?? null;

  const closeMenu = () => setOpen(false);

  const handleLogout = async (e) => {
    e?.preventDefault?.();
    try {
      await (logout?.());
      closeMenu();
      navigate("/");
    } catch (err) {
      console.error("Logout failed:", err);
    }
  };

  return (
    <header className="navbar">
      <Link to="/" className="logo-wrapper" onClick={closeMenu}>
        <img className="logo-image" src={LogoImg} alt="Captains Connections" />
      </Link>

      <button
        className="menu-toggle"
        aria-expanded={open}
        aria-controls="primary-nav"
        onClick={() => setOpen(v => !v)}
      >
        ☰
      </button>

      <nav id="primary-nav" className={`nav-links ${open ? "active" : ""}`}>
        <NavLink to="/services" onClick={closeMenu}>Our Services In Antigua</NavLink>
        <NavLink to="/destinations-and-itineraries" onClick={closeMenu}>Destinations & Itineraries</NavLink>

        <NavLink to="/contact" className="contact-button" onClick={closeMenu}>
          Contact
        </NavLink>

        {me ? (
          <>
            <NavLink to="/dashboard" onClick={closeMenu}>Dashboard</NavLink>
            <a href="/" onClick={handleLogout}>Log out</a>
          </>
        ) : (
          <>
            <NavLink to="/login" onClick={closeMenu}>Log in</NavLink>
            <NavLink to="/signup" className="contact-button" onClick={closeMenu}>
              Sign up
            </NavLink>
          </>
        )}
      </nav>

      {open && <div className="nav-backdrop open" onClick={closeMenu} />}
    </header>
  );
}
